<template>
    <footer class="bg-black pt-5">
        <div class="container-fluid">
            <div class="row py-5 p-lg-5 text-white mx-auto">
                <div class="col-lg-5 text-center px-3 px-lg-5">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Recibe información y promociones de Valle Nevado</h3>
                    <p>Descubre nuestra colección de experiencias únicas para vivir dentro de Valle Nevado durante todo el año</p>
                    <a href="https://vallenevado.com" target="_blank" class="btn btn-primary btn-lg mt-3 p-3">SUSCRIBIRSE</a>
                </div>
                <div class="col-lg-5 text-center px-3 px-lg-5 mx-auto pt-5 pt-lg-0">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Descarga la app</h3>
                    <p class="mb-3">Clima, cámaras web, enlaces, apertura de senderos y más.</p>
                    <a href='https://play.google.com/store/apps/details?id=com.blabsolutions.ValleNevadoApp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                        <img alt='Get it on Google Play' class="img-store"
                             src='~__STATIC__/img_link/google-play-badge.png'/>
                    </a>
                    <a href='https://itunes.apple.com/es/app/valle-nevado/id548238945?mt=8'>
                        <img alt='Get it on Google Play' class="img-store"
                             src='~__STATIC__/img_link/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'/>
                    </a>
                </div>
            </div>
<!--            <div class="row px-lg-5">
                <div class="border-line mx-auto"></div>
                <div class="row-partners text-white">
                    <div class="item">
                        <a href="#" target="_blank"><img src="~__STATIC__/img_link/powerpass.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="https://www.ikonpass.com/" target="_blank">
                            <svg alt="mountain icon" width="90" height="40" viewBox="0 0 90 40" xmlns="http://www.w3.org/2000/svg"><path d="M90 27.624c-.063.008-.125.025-.187.025-2.203 0-4.405 0-6.607.003a.298.298 0 0 1-.273-.137 10488.277 10488.277 0 0 0-11.93-16.162c-.022-.03-.05-.054-.107-.113v16.397H63.95V.89c.065-.003.121-.008.178-.008 2.196 0 4.393 0 6.59-.002.112 0 .192.023.265.121 2.524 3.418 5.051 6.834 7.578 10.25l4.315 5.833c.037.05.078.097.152.187V.882h.213l6.554.001c.069 0 .137.016.205.025v26.716zm0 9.326l-25.794-.001h-.256v-1.754c.063-.003.125-.008.187-.008h25.671c.064 0 .128.006.192.01v1.753zM48.712 40c-.435-.078-.876-.13-1.3-.241-.419-.11-.82-.282-1.25-.433l.856-2.205c.09.066.166.116.236.174.439.363.938.576 1.507.619.23.017.457.011.652-.136.112-.085.211-.204.152-.342-.045-.105-.149-.225-.252-.257-.27-.085-.554-.128-.833-.184-.377-.074-.75-.149-1.088-.354-.711-.433-1.01-1.077-.955-1.889.08-1.178.772-1.917 1.81-2.332 1.156-.462 2.316-.34 3.447.14.466.198.464.203.288.675l-.515 1.375c-.018.048-.04.095-.061.144-.26-.13-.507-.269-.765-.381-.33-.143-.675-.22-1.038-.16-.072.01-.16.03-.207.078-.079.083-.178.193-.179.292 0 .085.11.22.198.247.36.111.73.193 1.097.278.394.092.772.22 1.103.46.575.418.78 1.01.789 1.69.013 1.072-.619 2.014-1.663 2.427-.336.133-.704.188-1.058.278-.055.014-.111.025-.167.037h-.804zm8.46 0c-.389-.066-.786-.104-1.164-.207-.425-.115-.832-.292-1.249-.438-.092-.032-.114-.08-.079-.171.261-.667.52-1.335.78-2.002.005-.016.018-.029.038-.056.099.077.188.15.28.217.535.398 1.121.637 1.802.554.1-.012.217-.05.284-.117.083-.083.18-.218.166-.315-.015-.107-.133-.242-.238-.283-.208-.081-.44-.1-.66-.155-.37-.093-.765-.14-1.104-.303-.904-.434-1.285-1.27-1.09-2.287.196-1.02.856-1.657 1.776-2.02 1.146-.45 2.293-.34 3.415.13.504.212.502.212.306.724-.177.462-.349.926-.524 1.39-.012.031-.028.061-.042.09-.275-.136-.538-.282-.813-.398-.326-.137-.668-.208-1.023-.13a.556.556 0 0 0-.232.11c-.2.167-.176.4.067.497.214.084.447.122.67.183.365.098.743.163 1.09.305.882.36 1.327 1.155 1.236 2.155-.107 1.177-.802 1.891-1.857 2.287-.327.124-.686.163-1.03.24h-.805zm4.1-25.73c0 7.88-6.37 14.264-14.23 14.262-7.906-.001-14.254-6.384-14.225-14.35C32.845 6.337 39.197-.011 47.053 0c7.87.011 14.22 6.385 14.22 14.27zm-41.419 4.488c-.586.7-1.137 1.404-1.738 2.06-.31.34-.396.69-.392 1.133.02 1.823.009 3.646.009 5.469v.218h-6.946V.893h6.943v10.994l.045.017c.151-.194.304-.387.453-.582l6.525-8.593c.441-.58.88-1.161 1.328-1.736a.309.309 0 0 1 .213-.106c2.773-.005 5.546-.005 8.32-.004.044 0 .087.008.164.016-.186.229-.353.435-.522.64l-5.507 6.68c-1.466 1.778-2.931 3.555-4.4 5.329-.065.079-.068.126-.001.206A28217.899 28217.899 0 0 1 35.6 27.464c.039.048.073.1.137.186h-.226c-2.867 0-5.733 0-8.6.003a.34.34 0 0 1-.305-.149 3844.226 3844.226 0 0 0-6.661-8.642c-.024-.032-.053-.06-.092-.104zM.001 27.638V.894h6.933v26.746H.001zM0 36.936v-1.736h24.52v1.736H0zm44.098 2.954h-.187c-.856 0-1.713-.005-2.57.004-.15.002-.2-.054-.23-.186-.046-.21-.114-.416-.162-.626-.023-.106-.07-.143-.178-.142-.6.004-1.2.005-1.8 0-.108-.002-.14.042-.158.136-.052.268-.113.535-.17.806h-2.93c.01-.054.014-.105.03-.15.833-2.412 1.669-4.823 2.496-7.236.062-.184.138-.249.338-.246.885.014 1.77.009 2.657.003.125 0 .18.038.222.157.864 2.438 1.732 4.874 2.6 7.31.016.049.025.1.042.17zm-16.312-.01v-7.611c.053-.005.102-.012.152-.012 1.17-.001 2.341-.004 3.512 0 .631.003 1.238.112 1.782.46.782.502 1.163 1.232 1.21 2.148.03.569-.048 1.122-.352 1.616-.451.735-1.12 1.097-1.977 1.11-.472.007-.944.004-1.415.006h-.207v2.282h-2.705zm2.708-5.532c0 .43-.002.82.003 1.208 0 .033.045.094.07.094.295.006.6.047.865-.123a.61.61 0 0 0 .295-.626c-.03-.244-.148-.43-.392-.475-.27-.049-.548-.053-.841-.078zm9.927 2.748l-.522-2.266-.52 2.266h1.042zM55.01 16.357c.646-2.488-.045-5.941-2.805-8.195a8.172 8.172 0 0 0-9.928-.303c-2.927 2.11-3.97 5.723-3.163 8.703l2.888-3.017 1.342 1.253 3.905-4.5 4.197 5.036 1.51-1.399 2.054 2.422z" fill="#c7c7c7" fill-rule="evenodd"></path></svg>
                        </a>
                    </div>
                    <div class="item">
                        <a href="https://mountaincollective.com/" target="_blank"><img src="~__STATIC__/img_link/mountain-collective.svg" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="https://www.les3vallees.com/" target="_blank"><img src="~__STATIC__/img_link/3valles-1.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="http://chile.travel/" target="_blank"><img src="~__STATIC__/img_link/chile.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="http://www.jeep.cl/" target="_blank"><img src="~__STATIC__/img_link/jeep-1.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="https://royalguard.cl/" target="_blank"><img src="~__STATIC__/img_link/royal_guard.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="https://www.mastercard.cl/es-cl.html" target="_blank"><img src="~__STATIC__/img_link/mastercard.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="http://www.columbiachile.cl/" target="_blank"><img src="~__STATIC__/img_link/columbia-1.png" alt=""></a>
                    </div>
                    <div class="item">
                        <a href="https://www.isdin.com/es-CL/" target="_blank"><img src="~__STATIC__/img_link/logo_isdin-2.png" alt=""></a>
                    </div>
                </div>
                <div class="border-line mx-auto"></div>
            </div>-->
            <div class="row mt-5 px-3 px-lg-5 text-white">
<!--                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Valle Nevado ski resort</h3>
                    <p>
                        <a href="mailto:info@vallenevado.com" target="_blank">info@vallenevado.com</a>
                        <br>
                        Isidora Goyenechea 2800, oficina 502
                        <br>
                        Titanium La Portada
                    </p>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Reservas hoteleras</h3>
                    <p>
                        <a href="mailto:reservas@vallenevado.com" target="_blank">reservas@vallenevado.com</a>
                        <br>
                        BRA: 0800-892-0490
                        <br>
                        USD/CAN: 1-844-657-0466
                    </p>
                </div>-->

<!--                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Somos Valle Nevado</h3>
                    <p>
                        <a href="#" target="_blank" class="text-muted">Acerca de Valle Nevado</a>
                        <br>
                        <a href="https://vallenevado.com/es/informacion-corporativa/" target="_blank">Información</a>
                        <br>
                        <a href="#" target="_blank" class="text-muted">Sustentabilidad</a>
                        <br>
                        <a href="https://vallenevado.trabajando.cl/" target="_blank">Trabaja con nosotros</a>
                    </p>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Eventos</h3>
                    <p class="text-muted">
                        Eventos
                    </p>
                </div>-->
                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Normas y protocolos</h3>
                    <div class="d-block mb-2 font-weight-bold">
                        <a href="https://www.vallenevado.com/es/normas-de-seguridad/" target="_blank">Invierno</a></div>
                    <div class="d-block font-weight-bold">
                        <a href="https://www.vallenevado.com/es/montana/verano/registro-montanistas/">Verano</a></div>

                </div>
                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Acceso directo a servicios clientes tickets, pases y cuponeras</h3>
                    <div class="text-left">
                        <a href="https://sacvalleplus.vallenevado.com/" target="_blank" class="btn btn-primary btn-lg">SAC VALLE PLUS</a>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <h3 class="ff-n27-bold text-uppercase mb-3">Informaciones</h3>
<!--                    <div class="d-block mb-2 font-weight-bold">-->
<!--                        <a href="mailto:prensa@vallenevado.com" target="_blank">prensa@vallenevado.com</a></div>-->
                    <div class="d-block h5 font-weight-bold">
                        <a href="/faq">Preguntas frecuentes</a></div>
                    <div class="d-block mb-2 font-weight-bold">
                        <a href="https://www.vallenevado.com" target="_blank" >www.vallenevado.com</a></div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-3 py-3 py-lg-5 mb-3">
                    <a target="_blank" href="https://www.facebook.com/vallenevadoskiresort" class="btn-rss rounded-circle mr-1">
                        <img src="~__STATIC__/img_link/facebook.svg" class="img-fluid img-rss" alt="">
                    </a>
                    <a target="_blank" href="http://twitter.com/valle_nevado" class="btn-rss rounded-circle mr-1">
                        <img src="~__STATIC__/img_link/x-twitter.svg" class="img-fluid img-rss" alt="">
                    </a>
                    <a target="_blank" href="https://www.youtube.com/channel/UCeugwuttf3KGSyVuax_AzNw" class="btn-rss rounded-circle mr-1">
                        <img src="~__STATIC__/img_link/youtube.svg" class="img-fluid img-rss" alt="">
                    </a>
                    <a target="_blank" href="http://instagram.com/valle_nevado" class="btn-rss rounded-circle">
                        <img src="~__STATIC__/img_link/instagram.svg" class="img-fluid img-rss" alt="">
                    </a>
               </div>
            </div>
            <div class="row px-3 px-lg-5 py-3">
                <div class="col-12 border-line"></div>
                <div class="col-12 text-white mt-3">
                    <p>Copyright ©2025 - <a href="https://www.vallenevado.com" target="_blank">www.vallenevado.com</a></p>
                </div>
            </div>
        </div>
  </footer>
</template>

<script>
    import cartMixin from '../mixins/cartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        mixins: [cartMixin, siteConfig],

        props: {
            hasStickyFooter: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            cardType: {
                type: Object,
                default() {
                    return {};
                }
            }
        },

        computed: {
            applySticketFooter () {
                if (window.location.pathname === this.getUrl('homeUrl') && this.count) {
                    return true;
                }

                return this.hasStickyFooter;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue